import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './burger-icon.styl'

export default class BurgerIcon extends Component {
  static propTypes = {
    isOpen: PropTypes.bool
  }

  render() {
    const { isOpen } = this.props
    const classNames = [styles.menu]

    isOpen && classNames.push(styles.open)

    return (
      <div className={classNames.join(' ')}>
        <div className={styles.icon}>
          <div className={styles.spanOne} />
          <div className={styles.spanTwo} />
          <div className={styles.spanThree} />
        </div>
        <div className={styles.text}>
          <FormattedMessage id='label.menu' defaultMessage='Menu' />
        </div>
      </div>
    )
  }
}
